export default __webpack_public_path__ + "static/media/N-spanish.dd589120.svg";